export default __webpack_public_path__ + "static/media/preview-cells.94c7a5be.png";